module.exports = __webpack_public_path__ + "img/file.4d4546e6.svg";